var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1536 419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .st0, .st1, .st18, .st4, .st7, .st8, .st19, .st10, .st13, .st14, .st20, .st21, .st15 {\r\n        stroke: #7cc5bf;\r\n      }\r\n\r\n      .st0, .st1, .st18, .st4, .st19, .st15 {\r\n        fill: none;\r\n      }\r\n\r\n      .st0, .st1, .st4, .st7, .st8, .st10, .st13, .st14, .st15 {\r\n        mix-blend-mode: color-dodge;\r\n      }\r\n\r\n      .st0, .st1, .st4, .st7, .st10, .st13, .st14, .st15 {\r\n        stroke-width: 3.79px;\r\n      }\r\n\r\n      .st0, .st1, .st4, .st15 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .st1, .st10 {\r\n        opacity: .75;\r\n      }\r\n\r\n      .st2 {\r\n        font-size: 195.09px;\r\n      }\r\n\r\n      .st2, .st3, .st6, .st16, .st17 {\r\n        font-family: Poppins-Bold, Poppins;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .st2, .st6, .st9, .st11, .st16, .st17 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st18 {\r\n        stroke-width: 1.25px;\r\n      }\r\n\r\n      .st18, .st7, .st19, .st10, .st13, .st14, .st20, .st21 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .st3 {\r\n        font-size: 67.02px;\r\n      }\r\n\r\n      .st3, .st12, .st22, .st20, .st21 {\r\n        fill: #7cc5bf;\r\n      }\r\n\r\n      .st4, .st14 {\r\n        opacity: .26;\r\n      }\r\n\r\n      .st6 {\r\n        font-size: 27.37px;\r\n      }\r\n\r\n      .st7, .st8, .st10, .st13, .st14 {\r\n        fill: #cce8ef;\r\n      }\r\n\r\n      .st7, .st8, .st15 {\r\n        opacity: .5;\r\n      }\r\n\r\n      .st8 {\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 3.79px;\r\n      }\r\n\r\n      .st19 {\r\n        stroke-width: 2.65px;\r\n      }\r\n\r\n      .st9 {\r\n        font-family: Poppins-Medium, Poppins;\r\n        font-size: 28.29px;\r\n        font-weight: 500;\r\n      }\r\n\r\n      .st23 {\r\n        fill: #263358;\r\n      }\r\n\r\n      .st11 {\r\n        font-size: 21.43px;\r\n      }\r\n\r\n      .st11, .st12 {\r\n        font-family: Poppins-SemiBold, Poppins;\r\n        font-weight: 600;\r\n      }\r\n\r\n      .st24 {\r\n        opacity: .1;\r\n      }\r\n\r\n      .st12 {\r\n        font-size: 27.75px;\r\n      }\r\n\r\n      .st22 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .st20 {\r\n        stroke-width: .41px;\r\n      }\r\n\r\n      .st21 {\r\n        stroke-width: .88px;\r\n      }\r\n\r\n      .st16 {\r\n        font-size: 39.06px;\r\n      }\r\n\r\n      .st17 {\r\n        font-size: 51.19px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elementy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_11",
    "data-name": "Warstwa_1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "t\\u0142o",
    className: "st23",
    y: -0.9,
    width: 1536,
    height: 419.9
  }), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1493.09 19.81 1690.25 772.87 1434.64 347.47 1493.09 19.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1376.57 683.66 1690.25 772.87 1185.42 870.69 1376.57 683.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1468.83 548.66 1690.25 772.87 1376.57 683.66 1468.83 548.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1376.57 683.66 1185.42 870.69 1107.07 681.84 1376.57 683.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1468.83 548.66 1376.57 683.66 1332.29 549.85 1468.83 548.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "-9.34 -634.16 211.85 -403.61 90.04 -297.69 -9.34 -634.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1434.64 347.47 1332.29 549.85 1325.93 364.85 1434.64 347.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1399.15 151.53 1434.64 347.47 1336.79 180.73 1399.15 151.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1107.07 681.84 1185.42 870.69 983.93 737.01 1107.07 681.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1306.46 573.03 1266.96 559.67 1332.29 549.85 1306.46 573.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1294.83 584.18 1266.96 559.67 1306.46 573.03 1294.83 584.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1332.29 549.85 1266.96 559.67 1211.45 452.74 1332.29 549.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "983.93 737.01 950.16 784.04 898.59 688.51 983.93 737.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "-29.77 352.64 -59.62 334.79 -15.53 299.62 -29.77 352.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1368.99 -293.9 1281.38 33.57 1159.03 -169.02 1368.99 -293.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "671.75 770.43 777.91 836.12 608.96 787.25 671.75 770.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "950.16 784.04 852.06 777.51 898.59 688.51 950.16 784.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "983.93 737.01 898.59 688.51 973.85 670.89 983.93 737.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1434.64 347.47 1325.93 364.85 1293.45 217.83 1434.64 347.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "58.75 600 307.18 616.54 -184.08 797.66 58.75 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "-11.73 1415.66 254.44 1280.34 31.42 1768.97 -11.73 1415.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "-392.33 1313.98 -11.73 1415.66 -349.18 1667.29 -392.33 1313.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "126.49 803.28 234.47 793.87 169.65 1156.59 126.49 803.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "-438.86 1784.75 -187.91 1667.29 -395.7 2138.07 -438.86 1784.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "671.75 770.43 608.96 787.25 585.3 745.02 671.75 770.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-29.77 352.64 -15.53 299.62 62.68 356.8 -29.77 352.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "4.51 233.83 -43.18 155.66 28.6 168.85 4.51 233.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "281.98 -707.96 575.08 -630.37 330.91 -330.88 281.98 -707.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "110.3 465.58 95.26 473.75 65.73 422.35 110.3 465.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "585.3 745.02 529.59 740.27 517.01 704.39 585.3 745.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "62.68 -135.43 90.04 -297.69 330.91 -330.88 62.68 -135.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "38.73 244.53 4.51 233.83 28.6 168.85 38.73 244.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1325.93 364.85 1211.45 452.74 1236.91 310.16 1325.93 364.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1281.38 33.57 1325.15 118.01 1288.28 88.46 1281.38 33.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "973.85 670.89 898.59 688.51 925.36 637.3 973.85 670.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1325.15 118.01 1313.23 144.92 1288.28 88.46 1325.15 118.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "665.42 -399.82 941.08 -704.17 864.54 -370.97 665.42 -399.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "330.91 -330.88 575.08 -630.37 665.42 -399.82 330.91 -330.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1313.23 144.92 1239.25 167.39 1252.7 111.86 1313.23 144.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.73 422.35 62.68 356.8 142.91 393.84 65.73 422.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "412.79 634.98 307.18 616.54 352.25 576.92 412.79 634.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1211.45 452.74 1086.12 483.31 1110.7 414.02 1211.45 452.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "178.63 -20.58 62.68 -135.43 330.91 -330.88 178.63 -20.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "28.6 168.85 62.68 -135.43 178.63 -20.58 28.6 168.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "524.02 655.42 517.01 704.39 412.79 634.98 524.02 655.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "806.08 651.65 702.85 697.38 666.42 617.37 806.08 651.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1208.83 308.39 1211.45 452.74 1110.7 414.02 1208.83 308.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1293.45 217.83 1239.25 167.39 1313.23 144.92 1293.45 217.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1325.15 118.01 1281.38 33.57 1493.09 19.81 1325.15 118.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1159.03 -169.02 1281.38 33.57 1164.28 -64.39 1159.03 -169.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "941.08 -704.17 1040.04 -407.41 864.54 -370.97 941.08 -704.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "38.73 244.53 28.6 168.85 78.08 195.31 38.73 244.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "110.3 465.58 142.91 393.84 181.74 415.93 110.3 465.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "307.18 616.54 220.08 478.54 312.62 521.66 307.18 616.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1239.25 167.39 1208.83 308.39 978.64 179.45 1239.25 167.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "47.05 261.44 78.08 195.31 130.86 202.96 47.05 261.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "312.62 521.66 220.08 478.54 269.58 476.23 312.62 521.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "395.88 577.99 352.25 576.92 321.16 493.53 395.88 577.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "220.08 478.54 181.74 415.93 298.73 417.93 220.08 478.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "220.08 478.54 298.73 417.93 269.58 476.23 220.08 478.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1164.28 -64.39 1228.64 105.02 1056.65 15.1 1164.28 -64.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "859.12 513.12 806.08 651.65 757.43 495.64 859.12 513.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "321.16 493.53 269.58 476.23 326.13 461.61 321.16 493.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "312.62 521.66 269.58 476.23 321.16 493.53 312.62 521.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1040.04 -407.41 1106.26 -192.28 962.74 -301.49 1040.04 -407.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1106.26 -192.28 1159.03 -169.02 1093.69 -109.11 1106.26 -192.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "806.08 651.65 666.42 617.37 757.43 495.64 806.08 651.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "225.37 265.22 130.86 202.96 256.77 66.18 225.37 265.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "124.14 307.06 130.86 202.96 225.37 265.22 124.14 307.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "326.13 461.61 269.58 476.23 318.81 441.68 326.13 461.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "312.62 521.66 321.16 493.53 352.25 576.92 312.62 521.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1239.25 167.39 978.64 179.45 1032.58 60.65 1239.25 167.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1159.03 -169.02 1164.28 -64.39 1093.69 -109.11 1159.03 -169.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1093.69 -109.11 1164.28 -64.39 1104.08 -67.94 1093.69 -109.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "318.81 441.68 269.58 476.23 298.73 417.93 318.81 441.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "488.14 513.5 326.13 461.61 497.7 461.84 488.14 513.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "402.17 -154.99 330.91 -330.88 533.63 -146.98 402.17 -154.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "130.86 202.96 178.63 -20.58 256.77 66.18 130.86 202.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "665.42 -399.82 864.54 -370.97 790.17 -266.4 665.42 -399.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "757.43 495.64 516.39 562.32 497.7 461.84 757.43 495.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "881.56 415.36 859.12 513.12 757.43 495.64 881.56 415.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "311.21 360.06 293.42 385.49 290.54 303.39 311.21 360.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "181.74 415.93 225.37 265.22 290.54 303.39 181.74 415.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "516.39 562.32 488.14 513.5 497.7 461.84 516.39 562.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "330.91 -330.88 665.42 -399.82 604.99 -198.84 330.91 -330.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "293.42 385.49 311.21 360.06 298.73 417.93 293.42 385.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "955.49 -226.72 1040.53 -165.62 998.11 -157.11 955.49 -226.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "881.56 415.36 757.43 495.64 684.99 333.64 881.56 415.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "757.43 495.64 497.7 461.84 684.99 333.64 757.43 495.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "922.93 -199.16 955.49 -226.72 998.11 -157.11 922.93 -199.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "962.74 -301.49 875.06 -191.15 795.37 -251.07 962.74 -301.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "684.99 333.64 497.7 461.84 441.56 352.43 684.99 333.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "225.37 265.22 256.77 66.18 344.94 154.05 225.37 265.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "318 23.02 178.63 -20.58 410.99 -89.11 318 23.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "922.93 -199.16 875.06 -191.15 962.74 -301.49 922.93 -199.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1094.12 384.36 980.7 255.61 1208.83 308.39 1094.12 384.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "875.06 -191.15 919.06 -182.96 891.4 -162.44 875.06 -191.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "922.93 -199.16 919.06 -182.96 875.06 -191.15 922.93 -199.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "955.49 -226.72 922.93 -199.16 962.74 -301.49 955.49 -226.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "665.42 -399.82 790.17 -266.4 604.99 -198.84 665.42 -399.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "959.38 29.33 1032.58 60.65 954.13 65.52 959.38 29.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "932.66 -139.07 972.98 -89.6 927.61 -98.75 932.66 -139.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "256.77 66.18 320.25 34.1 336.6 89.5 256.77 66.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "417.45 325.07 362.88 259.31 418.57 298.7 417.45 325.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "927.61 -98.75 972.98 -89.6 878.61 -50.38 927.61 -98.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "891.4 -162.44 932.66 -139.07 892.98 -138.6 891.4 -162.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "410.99 -89.11 402.17 -154.99 533.63 -146.98 410.99 -89.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "336.6 89.5 320.25 34.1 378.53 .43 336.6 89.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "866.26 -179.01 875.06 -191.15 891.4 -162.44 866.26 -179.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "954.13 65.52 978.64 179.45 923.38 127.15 954.13 65.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "439.3 275.97 362.88 259.31 370.28 187.36 439.3 275.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "370.28 187.36 344.94 154.05 399.57 144.25 370.28 187.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "892.98 -138.6 932.66 -139.07 927.61 -98.75 892.98 -138.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "872.27 -151.28 891.4 -162.44 892.98 -138.6 872.27 -151.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "378.53 .43 318 23.02 410.99 -89.11 378.53 .43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "892.98 -138.6 927.61 -98.75 878.61 -50.38 892.98 -138.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "872.27 -151.28 892.98 -138.6 831.17 -122.02 872.27 -151.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "417.45 325.07 439.3 275.97 441.56 352.43 417.45 325.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "959.38 29.33 832.23 108.82 878.61 -50.38 959.38 29.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "336.6 89.5 378.53 .43 395.22 111.76 336.6 89.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "810.21 -170.58 777.75 -153.34 750.76 -162.06 810.21 -170.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "810.21 -170.58 787.9 -124.86 777.75 -153.34 810.21 -170.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "832.23 108.82 980.7 255.61 684.99 333.64 832.23 108.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "954.13 65.52 923.38 127.15 832.23 108.82 954.13 65.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "399.57 144.25 457.25 110.87 460.81 145.88 399.57 144.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "555.69 229.48 439.3 275.97 497.64 195.81 555.69 229.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "750.76 -162.06 777.75 -153.34 766.87 -125.15 750.76 -162.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "506.68 -26.91 533.63 -146.98 543.44 -12.67 506.68 -26.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "733.1 -159 750.76 -162.06 766.87 -125.15 733.1 -159"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "642.36 -137.75 733.1 -159 667.42 -121.45 642.36 -137.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "733.1 -159 766.87 -125.15 667.42 -121.45 733.1 -159"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "761.77 -29.39 878.61 -50.38 832.23 108.82 761.77 -29.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "497.64 195.81 460.81 145.88 580.92 103.26 497.64 195.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "533.63 -146.98 642.36 -137.75 621.27 -78.27 533.63 -146.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "460.81 145.88 457.25 110.87 580.92 103.26 460.81 145.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "555.69 229.48 497.64 195.81 580.92 103.26 555.69 229.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "621.27 -78.27 667.42 -121.45 703.76 -57.13 621.27 -78.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "657.24 163.12 555.69 229.48 580.92 103.26 657.24 163.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "684.99 333.64 555.69 229.48 657.24 163.12 684.99 333.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "457.25 110.87 506.68 -26.91 543.44 -12.67 457.25 110.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "761.77 -29.39 832.23 108.82 684.49 43.32 761.77 -29.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "766.87 -125.15 761.77 -29.39 711.51 -49.59 766.87 -125.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "580.92 103.26 543.44 -12.67 608.74 19.43 580.92 103.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "634.67 -20.64 711.51 -49.59 665.92 34.21 634.67 -20.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "657.24 163.12 580.92 103.26 630.34 47.17 657.24 163.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "630.34 47.17 608.74 19.43 665.92 34.21 630.34 47.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "684.49 43.32 630.34 47.17 665.92 34.21 684.49 43.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "-378.28 -245.68 -255.46 -109.11 -387.05 -151.2 -378.28 -245.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1329.72 -566.42 1201.62 -396.03 1213.53 -658.51 1329.72 -566.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1482.27 -592.73 1434.64 -384.75 1670.2 -563.92 1482.27 -592.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1003.06 889.77 845.23 874.48 974.85 942.69 1003.06 889.77"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 256.77,
    cy: 66.18,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1104.08,
    cy: -67.94,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 777.75,
    cy: -153.34,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 344.94,
    cy: 154.05,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 684.49,
    cy: 43.32,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 110.3,
    cy: 465.58,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 533.63,
    cy: -146.98,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 330.91,
    cy: -330.88,
    r: 3.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M66.47-135.43c0,2.1-1.7,3.79-3.79,3.79s-3.79-1.7-3.79-3.79,1.7-3.79,3.79-3.79,3.79,1.7,3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 402.17,
    cy: -154.99,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -9.34,
    cy: -634.16,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1468.83,
    cy: 548.66,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1098.9,
    cy: 541.27,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 311.21,
    cy: 360.06,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 832.23,
    cy: 108.82,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 919.06,
    cy: -182.96,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: -65.41,
    cy: 503.45,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 665.92,
    cy: 34.21,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1313.23,
    cy: 144.92,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 831.17,
    cy: -122.02,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 859.12,
    cy: 513.12,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 1110.7,
    cy: 414.02,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 439.3,
    cy: 275.97,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 124.14,
    cy: 307.06,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 1399.15,
    cy: 151.53,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1430.84,
    cy: -305.28,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 703.76,
    cy: -57.13,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 955.49,
    cy: -226.72,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1040.04,
    cy: -407.41,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 757.43,
    cy: 495.64,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 65.73,
    cy: 422.35,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1018.61,
    cy: -141.26,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 269.58,
    cy: 476.23,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 671.75,
    cy: 770.43,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 441.56,
    cy: 352.43,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 905.86,
    cy: 642.62,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: -13.13,
    cy: 380.14,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 876.9,
    cy: 616.37,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 290.54,
    cy: 303.39,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 298.73,
    cy: 417.93,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 273.15,
    cy: 282.21,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 225.37,
    cy: 265.22,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1056.65,
    cy: 15.1,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1336.79,
    cy: 180.73,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 962.74,
    cy: -301.49,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 580.92,
    cy: 103.26,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: -79.87,
    cy: 408.08,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 875.06,
    cy: -191.15,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 777.91,
    cy: 836.12,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 1281.38,
    cy: 33.57,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 810.21,
    cy: -170.58,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 983.93,
    cy: 737.01,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1293.45,
    cy: 217.83,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 130.86,
    cy: 202.96,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 898.59,
    cy: 688.51,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 959.38,
    cy: 29.33,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 321.16,
    cy: 493.53,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 750.76,
    cy: -162.06,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1306.46,
    cy: 573.03,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1185.42,
    cy: 870.69,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1690.25,
    cy: 772.87,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 1493.09,
    cy: 19.81,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 326.13,
    cy: 461.61,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1106.26,
    cy: -192.28,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1093.69,
    cy: -109.11,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 998.11,
    cy: -157.11,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 418.57,
    cy: 298.7,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 950.16,
    cy: 784.04,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1294.83,
    cy: 584.18,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 488.14,
    cy: 513.5,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 543.44,
    cy: -12.67,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 395.22,
    cy: 111.76,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 318.81,
    cy: 441.68,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 608.74,
    cy: 19.43,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 378.53,
    cy: 0.43,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1086.12,
    cy: 483.31,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 972.98,
    cy: -89.6,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 795.37,
    cy: -251.07,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 352.25,
    cy: 576.92,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 657.24,
    cy: 163.12,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 281.98,
    cy: -707.96,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 980.7,
    cy: 255.61,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 307.18,
    cy: 616.54,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 169.46,
    cy: 1155.23,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 254.44,
    cy: 1280.34,
    r: 3.79,
    transform: "translate(-139.83 35.93) rotate(-6.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 127.27,
    cy: 802.96,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 234.47,
    cy: 793.87,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 31.84,
    cy: 1768.97,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: -11.91,
    cy: 1415.41,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: -188.06,
    cy: 1667.93,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 872.27,
    cy: -151.28,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: -29.77,
    cy: 352.64,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 4.51,
    cy: 233.83,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 761.77,
    cy: -29.39,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -45.69,
    cy: 258.9,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 362.88,
    cy: 259.31,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 927.61,
    cy: -98.75,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 666.42,
    cy: 617.37,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 621.27,
    cy: -78.27,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 852.06,
    cy: 777.51,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 318,
    cy: 23.02,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 38.73,
    cy: 244.53,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1211.45,
    cy: 452.74,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 850.9,
    cy: 700.99,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 125.13,
    cy: 551.66,
    r: 3.79,
    transform: "translate(-60.15 17.19) rotate(-6.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 336.6,
    cy: 89.5,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 412.79,
    cy: 634.98,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 220.08,
    cy: 478.54,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 575.08,
    cy: -630.37,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 733.1,
    cy: -159,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 536.32,
    cy: 597.19,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 836.32,
    cy: -151.6,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 516.39,
    cy: 562.32,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 608.96,
    cy: 787.25,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 181.74,
    cy: 415.93,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 555.69,
    cy: 229.48,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 790.17,
    cy: -266.4,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 665.42,
    cy: -399.82,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 312.62,
    cy: 521.66,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 28.6,
    cy: 168.85,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1325.15,
    cy: 118.01,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1040.53,
    cy: -165.62,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 854.02,
    cy: 634.28,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 529.59,
    cy: 740.27,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 787.9,
    cy: -124.86,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 517.01,
    cy: 704.39,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 973.85,
    cy: 670.89,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1368.99,
    cy: -293.9,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 766.87,
    cy: -125.15,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: -43.18,
    cy: 155.66,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: -184.08,
    cy: 797.66,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: -187.87,
    cy: 338.17,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -130.24,
    cy: -185.47,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1032.58,
    cy: 60.65,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 78.08,
    cy: 195.31,
    r: 3.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1243.04,167.39c0,2.1-1.7,3.79-3.79,3.79s-3.79-1.7-3.79-3.79,1.7-3.79,3.79-3.79,3.79,1.7,3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 891.4,
    cy: -162.44,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: -15.53,
    cy: 299.62,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1236.91,
    cy: 310.16,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 932.66,
    cy: -139.07,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1172.85,
    cy: 540.78,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1288.28,
    cy: 88.46,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 58.75,
    cy: 600,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -255.46,
    cy: -110.32,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1208.83,
    cy: 308.39,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 370.28,
    cy: 187.36,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 634.67,
    cy: -20.64,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 954.13,
    cy: 65.52,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 399.57,
    cy: 144.25,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 585.3,
    cy: 745.02,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 47.05,
    cy: 261.44,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1434.64,
    cy: 347.47,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1159.03,
    cy: -169.02,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 864.54,
    cy: -370.97,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 978.64,
    cy: 179.45,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 457.25,
    cy: 110.87,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1225.88,
    cy: 534.72,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 506.68,
    cy: -26.91,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 925.36,
    cy: 637.3,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1325.93,
    cy: 364.85,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1164.28,
    cy: -64.39,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1376.57,
    cy: 683.66,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 923.38,
    cy: 127.15,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 868.53,
    cy: 698.74,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 642.36,
    cy: -137.75,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 353.78,
    cy: 249.83,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 320.25,
    cy: 34.1,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 417.45,
    cy: 325.07,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 410.99,
    cy: -89.11,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 178.63,
    cy: -20.58,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 90.04,
    cy: -297.69,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 211.85,
    cy: -403.61,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 460.81,
    cy: 145.88,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1094.12,
    cy: 384.36,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1208.78,
    cy: 539.47,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1252.7,
    cy: 111.86,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 604.99,
    cy: -198.84,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 922.93,
    cy: -199.16,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 497.64,
    cy: 195.81,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1228.64,
    cy: 105.02,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1266.96,
    cy: 559.67,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 878.61,
    cy: -50.38,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 142.91,
    cy: 393.84,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 62.68,
    cy: 356.8,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: -59.62,
    cy: 334.79,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 630.34,
    cy: 47.17,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 95.26,
    cy: 473.75,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1332.29,
    cy: 549.85,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 257.76,
    cy: 57.09,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 941.08,
    cy: -704.17,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 892.98,
    cy: -138.6,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 293.42,
    cy: 385.49,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1107.07,
    cy: 681.84,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 711.51,
    cy: -49.59,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 497.7,
    cy: 461.84,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 667.42,
    cy: -121.45,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 702.85,
    cy: 697.38,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 684.99,
    cy: 333.64,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 881.56,
    cy: 415.36,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 806.08,
    cy: 651.65,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 524.02,
    cy: 655.42,
    r: 3.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 866.26,
    cy: -179.01,
    r: 3.79
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "1218.37 -1280.96 1484.54 -1416.27 1261.53 -927.64 1218.37 -1280.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "837.77 -1382.64 1218.37 -1280.96 880.93 -1029.32 837.77 -1382.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "791.25 -911.87 1042.2 -1029.32 834.4 -558.55 791.25 -911.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "851.83 -2942.3 974.65 -2805.73 843.06 -2847.82 851.83 -2942.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2559.83 -3263.04 2431.73 -3092.65 2443.64 -3355.13 2559.83 -3263.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2233.17 -1806.85 2075.33 -1822.14 2204.96 -1753.93 2233.17 -1806.85"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st23",
    x: 682.6,
    y: 151.06,
    width: 685.8,
    height: 119.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "tekst"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(164.17 361.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W NAUCE"))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 327.93,
    y: 39.05,
    width: 71.64,
    height: 4.74
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st21",
    x: 174.76,
    y: 378.57,
    width: 324.78,
    height: 4.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    cx: 507.46,
    cy: 381,
    rx: 8.19,
    ry: 8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "translate(172.01 52.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "XII EDYCJA"))))), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(167.63 292.07)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GIS"))))), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st6",
    transform: "translate(171.49 88.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OG\xD3LNOPOLSKA")))), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st6",
    transform: "translate(171.49 120.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KONFERECJA")))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st16",
    transform: "translate(1088.74 211.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Hotel Omega")))), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(1088.74 242.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "w Olsztynie"))))), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1013.51,222.15c-6.89,1.21-12.27,3.18-15.11,5.43-2.05,1.63-2.98,3.51-2.98,5.35,0,2.28,1.54,4.69,4.83,6.58,5.62,3.24,16.92,5.55,29.96,5.55s24.34-2.31,29.96-5.55c3.28-1.89,4.83-4.3,4.83-6.58,0-1.84-.94-3.72-2.98-5.35-2.84-2.26-8.21-4.22-15.11-5.43,4.97-7.21,8.81-16.15,8.81-23.19,0-14.73-11.43-26.69-25.51-26.69s-25.51,11.96-25.51,26.69c0,7.04,3.84,15.98,8.81,23.19h0ZM1043.55,226.53c-2.6,3.07-5.33,5.53-7.84,7.04-1.98,1.18-3.86,1.79-5.51,1.79s-3.53-.6-5.51-1.79c-2.51-1.5-5.24-3.97-7.84-7.04-6.19.86-11.27,2.27-14.39,4.08-.87.5-1.57,1.02-2.03,1.58-.2.25-.38.47-.38.74,0,.46.38.81.85,1.23.92.82,2.27,1.56,3.94,2.24,5.72,2.33,14.95,3.81,25.36,3.81s19.64-1.48,25.36-3.81c1.68-.68,3.03-1.42,3.94-2.24.46-.41.85-.77.85-1.23,0-.27-.17-.49-.38-.74-.46-.56-1.16-1.08-2.03-1.58-3.12-1.81-8.21-3.22-14.39-4.08h0ZM1030.2,177.13c11.52,0,20.87,9.79,20.87,21.84,0,7.55-5.19,17.48-10.92,24.26-2.25,2.66-4.58,4.84-6.75,6.14-1.16.69-2.24,1.15-3.2,1.15s-2.04-.45-3.2-1.15c-2.17-1.3-4.5-3.47-6.75-6.14-5.73-6.78-10.92-16.71-10.92-24.26,0-12.05,9.35-21.84,20.87-21.84h0ZM1030.2,186.83c-6.4,0-11.59,5.43-11.59,12.13s5.19,12.13,11.59,12.13,11.59-5.43,11.59-12.13-5.19-12.13-11.59-12.13ZM1030.2,191.69c3.84,0,6.96,3.26,6.96,7.28s-3.12,7.28-6.96,7.28-6.96-3.26-6.96-7.28,3.12-7.28,6.96-7.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st17",
    transform: "translate(792.83 214.84)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "24-25")))), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(792.83 243.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "wrze\u015Bnia 2026"))))), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M720.04,200.31h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97h8.36c.54,0,.97-.43.97-.97v-8.36c0-.54-.43-.97-.97-.97ZM719.06,208.67h-6.42v-6.42h6.42v6.42ZM735.23,200.31h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97h8.36c.54,0,.97-.43.97-.97v-8.36c0-.54-.43-.97-.97-.97ZM734.26,208.67h-6.42v-6.42h6.42v6.42ZM750.43,200.31h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97h8.36c.54,0,.97-.43.97-.97v-8.36c0-.54-.43-.97-.97-.97ZM749.46,208.67h-6.42v-6.42h6.42v6.42ZM757.26,210.61h8.36c.54,0,.97-.43.97-.97v-8.36c0-.54-.43-.97-.97-.97h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97ZM758.23,202.25h6.42v6.42h-6.42v-6.42ZM720.04,214h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97h8.36c.54,0,.97-.43.97-.97v-8.36c0-.54-.43-.97-.97-.97ZM719.06,222.36h-6.42v-6.42h6.42v6.42ZM735.23,214h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97h8.36c.54,0,.97-.43.97-.97v-8.36c0-.54-.43-.97-.97-.97ZM734.26,222.36h-6.42v-6.42h6.42v6.42ZM750.43,214h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97h8.36c.54,0,.97-.43.97-.97v-8.36c0-.54-.43-.97-.97-.97ZM749.46,222.36h-6.42v-6.42h6.42v6.42ZM757.26,224.3h8.36c.54,0,.97-.43.97-.97v-8.36c0-.54-.43-.97-.97-.97h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97ZM758.23,215.94h6.42v6.42h-6.42v-6.42ZM720.04,227.68h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97h8.36c.54,0,.97-.43.97-.97v-8.36c0-.54-.43-.97-.97-.97ZM719.06,236.05h-6.42v-6.42h6.42v6.42ZM735.23,227.68h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97h8.36c.54,0,.97-.43.97-.97v-8.36c0-.54-.43-.97-.97-.97ZM734.26,236.05h-6.42v-6.42h6.42v6.42ZM750.43,227.68h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97h8.36c.54,0,.97-.43.97-.97v-8.36c0-.54-.43-.97-.97-.97ZM749.46,236.05h-6.42v-6.42h6.42v6.42ZM770.11,180.27h-1.3v-3.18c0-1.9-1.54-3.44-3.44-3.44h-1.65c-.92,0-1.78.36-2.43,1.01s-1.01,1.51-1.01,2.43v3.18h-4.41v-3.18c0-1.9-1.54-3.44-3.44-3.44h-1.65c-.92,0-1.78.36-2.43,1.01s-1.01,1.51-1.01,2.43v3.18h-4.41v-3.18c0-1.9-1.54-3.44-3.44-3.44h-1.65c-.92,0-1.78.36-2.43,1.01s-1.01,1.51-1.01,2.43v3.18h-4.41v-3.18c0-1.9-1.54-3.44-3.44-3.44h-1.65c-.92,0-1.78.36-2.43,1.01s-1.01,1.51-1.01,2.43v3.18h-4.41v-3.18c0-1.9-1.54-3.44-3.44-3.44h-1.65c-.92,0-1.78.36-2.43,1.01s-1.01,1.51-1.01,2.43v3.18h-1.3c-3.24,0-5.88,2.64-5.88,5.88v53.37c0,3.24,2.64,5.88,5.88,5.88h62.91c3.24,0,5.88-2.64,5.88-5.88v-53.37c0-3.24-2.64-5.88-5.88-5.88h-.02,0ZM762.22,177.09c0-.4.16-.77.44-1.06s.66-.44,1.06-.44h1.65c.83,0,1.5.67,1.5,1.5v8.23c0,.83-.67,1.5-1.5,1.5h-1.65c-.83,0-1.5-.67-1.5-1.5v-8.23h0ZM749.27,177.09c0-.4.16-.77.44-1.06s.66-.44,1.06-.44h1.65c.83,0,1.5.67,1.5,1.5v8.23c0,.83-.67,1.5-1.5,1.5h-1.65c-.83,0-1.5-.67-1.5-1.5v-8.23h0ZM736.32,177.09c0-.4.16-.77.44-1.06s.66-.44,1.06-.44h1.65c.83,0,1.5.67,1.5,1.5v8.23c0,.83-.67,1.5-1.5,1.5h-1.65c-.83,0-1.5-.67-1.5-1.5v-8.23h0ZM723.38,177.09c0-.4.16-.77.44-1.06s.66-.44,1.06-.44h1.65c.83,0,1.5.67,1.5,1.5v8.23c0,.83-.67,1.5-1.5,1.5h-1.65c-.83,0-1.5-.67-1.5-1.5v-8.23h0ZM710.43,177.09c0-.4.16-.77.44-1.06s.66-.44,1.06-.44h1.65c.83,0,1.5.67,1.5,1.5v8.23c0,.83-.67,1.5-1.5,1.5h-1.65c-.83,0-1.5-.67-1.5-1.5v-8.23h0ZM707.19,182.21h1.3v3.11c0,1.9,1.54,3.44,3.44,3.44h1.65c1.9,0,3.44-1.54,3.44-3.44v-3.11h4.41v3.11c0,1.9,1.54,3.44,3.44,3.44h1.65c1.9,0,3.44-1.54,3.44-3.44v-3.11h4.41v3.11c0,1.9,1.54,3.44,3.44,3.44h1.65c1.9,0,3.44-1.54,3.44-3.44v-3.11h4.41v3.11c0,1.9,1.54,3.44,3.44,3.44h1.65c1.9,0,3.44-1.54,3.44-3.44v-3.11h4.41v3.11c0,1.9,1.54,3.44,3.44,3.44h1.65c1.9,0,3.44-1.54,3.44-3.44v-3.11h1.3c2.17,0,3.94,1.77,3.94,3.94v6.94h-70.79v-6.94c0-2.17,1.77-3.94,3.94-3.94h.02,0ZM703.25,239.52v-44.49h70.79v37.51h-7.45v-3.89c0-.54-.43-.97-.97-.97h-8.36c-.54,0-.97.43-.97.97v8.36c0,.54.43.97.97.97h4.67v5.48h-54.74c-2.17,0-3.94-1.77-3.94-3.94h0ZM761.94,233.52v2.53h-3.7v-6.42h6.42v2.92h-1.75c-.54,0-.97.43-.97.97ZM770.11,243.47h-6.23v-8.98h10.17v5.04c0,2.17-1.77,3.94-3.94,3.94Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st19",
    x: 682.57,
    y: 151.06,
    width: 685.8,
    height: 119.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 970.22,
    y: 151.06,
    width: 1.39,
    height: 119.15
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBackground);
export default __webpack_public_path__ + "static/media/header_background.575bcf83be8331b9d0d936dd5006fe40.svg";
export { ForwardRef as ReactComponent };